export enum ServiceRouteName {
    Index = 'sales.services.index',
    Create = 'sales.services.create',
    Edit = 'sales.services.edit',
    Details = 'sales.services.details',
}

export default {
    path: 'services',
    name: ServiceRouteName.Index,
    component: () => import('@/views/sales/services/Index.vue'),
    meta: {
        label: 'Services',
        auth: true,
        permission: 'manage-services',
        icon: 'fal fa-shopping-cart fa-fw',
        location: 'sidebar',
        parent: 'sales',
    },
    children: [
        {
            path: 'create',
            name: ServiceRouteName.Create,
            component: () => import('@/views/sales/services/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Service',
                permission: 'manage-services',
                parent: 'sales.services.index',
            },
        },
        {
            path: ':serviceId?/edit',
            name: ServiceRouteName.Edit,
            component: () => import('@/views/sales/services/Index.vue'),
            meta: {
                label: 'Edit Service',
                auth: true,
                permission: 'manage-services',
                parent: 'sales.services.index',
            },
        },
        {
            path: ':serviceId?/details',
            name: ServiceRouteName.Details,
            component: () => import('@/views/sales/services/Index.vue'),
            meta: {
                label: 'Service Details',
                auth: true,
                permission: 'manage-services',
                parent: 'sales.services.index',
            },
        },
    ],
}
